export default __webpack_public_path__ + "static/media/attach.3d76a644.svg";